<template>
  <div class="gridSection">
    <div class="CustomGrid" id="gridc" v-if="LoadGrid">
      <div class="row RequestDate" v-if="AllowEditing">
        <div class="col-md-3">Request Decommission Date:</div>
        <div class="col-md-2">
          <DxDateBox
            placeholder="Activation Date"
            type="date"
            :value="new Date()"
            @value-changed="dateValueChanged"            
          />
        </div>
      </div>
      <div class="count" v-if="this.selectedRowsCount != undefined && AllowEditing == false">
        Current Count: {{ this.selectedRowsCount }}
      </div>
      <DxDataGrid
        id="event-datagrid"
        :data-source="AllowEditing ? selectedRowsDataSource : decommissionChannelDatasource "
        :show-borders="false"
        :ref="gridRefName"
        :width="100 + '%'"
        :showColumnLines="true"
        :wordWrapEnabled="true"
        :headerFilter="{ visible: false }"
        @toolbar-preparing="onToolbarPreparing"
        :onContentReady="onContentReady"
        :remote-operations="false"
        @selection-changed="onSelectionChanged"
      >
        <DxSelection v-if="!AllowEditing"
          select-all-mode="allPages"
          show-check-boxes-mode="always"
          mode="multiple"
        />
        <DxEditing v-if="!AllowEditing" :allow-updating="true" mode="batch" />
        <DxSearchPanel :visible="true" :width="240" placeholder="Search..." />
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />
        <DxPaging :page-size="8" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20, 50]"
          :show-info="true"
        />
        <DxColumn
          data-field="ProductInstanceID"
          caption="Product Instance ID"
          data-type="number"
          width="90"
          alignment="left"
          :fixed="true"
        />
        <DxColumn
          data-field="OrderRequestName"
          caption="Channel Requested"
          data-type="string"
          width="90"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
        />
        <DxColumn
          data-field="ClientReferenceID"
          caption="DSrcID"
          data-type="string"
          width="90"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          :visible="true"
        />
        <DxColumn
          data-field="DMA_Name"
          caption="Market"
          data-type="string"
          width="90"
          :allowHeaderFiltering="true"
          :header-filter="{ allowSearch: true }"
          alignment="left"
          :fixed="true"
          cell-template="DMA-channel-cell-template"
          :calculate-cell-value="DMAValueCalculate"
        />
        <template #DMA-channel-cell-template="cell">
          <div>
            <router-link :to="`market-dashboard/${cell.data.data.DMA_RecID}`">
              <span
                v-if="cell.data.data != null"
                style="text-decoration: underline; cursor: pointer"
                :title="`${
                  cell.data.data.DMA_Name ? cell.data.data.DMA_Name : ''
                }`"
                @click="resetDMADashboard()"
                >{{ cell.data.data.DMA_Name }}</span
              >
            </router-link>
            <span v-if="cell.data.data.DMA_Rank">
              ({{ cell.data.data.DMA_Rank }})</span
            >
          </div>
        </template>
        <template #ClearBtn>
          <DxButton
            icon="fas fa-filter"
            hint="Clear All Filters"
            styling-mode="contained"
            :elementAttr="{ id: 'ClearAllBtn' }"
            :ref="'ClearAllBtnRef'"
            @click="clearDataGridFilters()"
            :disabled="!isFiltered"
          />
        </template>
      </DxDataGrid>
      <DxLoadPanel
        :position="loaderPosition"
        :visible.sync="loaderVisible"
        :show-indicator="true"
        shading-color="rgba(0,0,0,0.4)"
      />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxFilterRow,
  DxHeaderFilter,
  DxSearchPanel,
  DxScrolling,
  DxPaging,
  DxPager,
  DxSelection,
} from "devextreme-vue/data-grid";
import { DxButton } from "devextreme-vue";
import DxDateBox from 'devextreme-vue/date-box';
import { DxLoadPanel } from "devextreme-vue/load-panel";
export default {
  name: "DecommissionChannelGrid",
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxFilterRow,
    DxHeaderFilter,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
    DxPager,
    DxSelection,
    DxButton,
    DxLoadPanel,
    DxDateBox,
  },
  data() {
    return {
      gridRefName: "decommisssionChannelsGrid",
      user: this.$auth.user.UserDetails,
      isFiltered: false,
      selectedRowsCount: undefined,
      selectedRowsData: [],
      loaderVisible: false,
      loaderPosition: { of: ".gridSection" },
      LoadGrid: false,
    };
  },
  props: {
    selectedRowsDataSource : Array,
    AllowEditing :Boolean
  },
  mounted: function () {
    let th = this;
    setTimeout(function () {
      th.LoadGrid = true;
    }, 100);
  },
  computed: {
    decommissionChannelDatasource: function () {
      var company = this.$auth.user.UserDetails.Company_RecID;
      let th = this;
      return {
        store: {
          type: "odata",
          url: "https://api.ccr.net/ColoM360/ProductInstanceChannel_View",
          key: "ProductInstanceID",
          version: 4,
          beforeSend: function (request) {
            let headers = {
              Authorization: `Bearer ${th.user.id_token}`,
            };
            if (th.user.Contact_Company_RecID != th.user.Company_RecID) {
              headers["CompanyID"] = th.user.Company_RecID;
            }
            request.headers = headers;

            let pth = request.url;
            if (pth[pth.length - 1] != ")") {
              if (request.params.$filter == undefined) {
                request.params.$filter =
                  "( Company_RecID eq " +
                  company +
                  " and InactiveFlag eq " +
                  false +
                  ")";
              } else {
                request.params.$filter =
                  "(" +
                  request.params.$filter +
                  ") and ( Company_RecID eq " +
                  company +
                  " and InactiveFlag eq " +
                  false +
                  ")";
              }
            }
          },
        },
      };
    },
  },
  methods: {
    dateValueChanged(e){
      this.$emit("requested-date-confirm", e.value);
    },
    onSelectionChanged(e) {
      this.selectedRowsCount = e.selectedRowKeys.length;
      this.selectedRowsData = e.selectedRowsData;
      this.$emit("set-selectedRows-grid", this.selectedRowsData);
    },
    DMAValueCalculate(rowData) {
      return rowData.DMA_Name + " (" + rowData.DMA_Rank + ") ";
    },
    resetDMADashboard() {
      //reset DMA Details filter to Dashboard and not Project
      setTimeout(() => {
        EventBus.$emit("DMA-Filter", "Dashboard");
      }, 1);
    },
    onContentReady(e) {
      if (e.component.getCombinedFilter() == undefined) {
        this.isFiltered = false;
      } else {
        this.isFiltered = true;
      }
    },
    clearDataGridFilters() {
      this.$refs[this.gridRefName].instance.clearFilter();
    },
    refreshDataGrid() {
      this.$refs[this.gridRefName].instance.refresh();
    },
    ExportDataGrid() {
      this.$refs[this.gridRefName].instance.exportToExcel(false);
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
      var customButtons = [
        {
          location: "before",
          template: "ClearBtn",
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Export to Excel",
            icon: "fad fa-file-excel",
            onClick: this.ExportDataGrid.bind(this),
            elementAttr: { id: "ExcelBtn" },
          },
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Refresh Grid",
            icon: "fad fa-sync",
            onClick: this.refreshDataGrid.bind(this),
            elementAttr: { id: "RefreshBtn" },
          },
        },
      ];
      toolbarItems.push(...customButtons);
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (
          e.toolbarOptions.items[i].name == "saveButton" ||
          e.toolbarOptions.items[i].name == "addRowButton" ||
          e.toolbarOptions.items[i].name == "revertButton"
        ) {
          e.toolbarOptions.items[i].visible = false;
        }

        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#gridc ::v-deep {
  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type {
    max-width: 50px;
    padding-right: 10px;
  }
}
.count {
  padding-left: 15px;
  color: gray;
  font-weight: bold;
}
.CustomGrid{
  padding: 0 20px;
}
.RequestDate {
  color: gray;
  font-weight: bold;
}
</style>